import { render, staticRenderFns } from "./productInfo.vue?vue&type=template&id=f8f79a60&scoped=true&"
import script from "./productInfo.vue?vue&type=script&lang=ts&"
export * from "./productInfo.vue?vue&type=script&lang=ts&"
import style0 from "./productInfo.vue?vue&type=style&index=0&id=f8f79a60&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f79a60",
  null
  
)

export default component.exports